module.exports = __webpack_public_path__ + "static/media/S (193).780038c2.jpg";